// extracted by mini-css-extract-plugin
export default {"message":"confirmationModal_message__yumyD"};